import { Box, BoxProps, FormLabel, FormLabelProps, styled } from '@mui/material'

export const Container = styled(Box)<BoxProps>({})

export const Label = styled(FormLabel)<FormLabelProps>({
  borderBottom: 'none',
  fontSize: '0.8rem',
})
